import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  alpha
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";

import { Logout } from "@mui/icons-material";
import AppsIcon from '@mui/icons-material/Apps';
import BadgeIcon from '@mui/icons-material/Badge';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from '@mui/icons-material/People';
import useUser from "../../../hooks/useUser";
import CourseManagement from "./courses/CourseManagement";
import StudentManagement from "./student/StudentManagement";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import { toast } from "react-toastify";
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import RegistrationManagement from "./Registration/RegistrationManagement";
import EmployeeManagement from "./employee/EmployeeManagement";
import CenterUserManagement from "./centerUsers/CenterUserManagement";
import CenterStudentsView from "./centerStudents/CenterStudentsView";
import SchoolIcon from '@mui/icons-material/School';

// Drawer settings
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  backgroundImage: "linear-gradient(to right, #454751d1 0%, #454751d1 100%);",
  color: "#fff",
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  width: `60px`,
  backgroundImage: "linear-gradient(to right, #454751d1 0%, #454751d1 100%);",
  color: "#fff",
  overflowX: "hidden",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.black, 0.05),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.1),
  },
  marginLeft: theme.spacing(2),
  width: "auto",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  paddingLeft: `calc(1em + ${theme.spacing(4)})`,
  width: "20ch",
}));

export default function Dashboard() {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedComponent, setSelectedComponent] = useState("Home");
  const [openLogoutDialog, setLogoutDialog] = useState(false);
  const { userLogoutMutation, isLoggingOut } = useUser()

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileView = window.innerWidth < 768;
      setIsMobile(isMobileView);
      if (isMobileView) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);



  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>

        <ListItemIcon >
          <PersonIcon fontSize="medium" />
        </ListItemIcon>
        <ListItemText>Profile</ListItemText>
      </MenuItem>
      <MenuItem onClick={() => { handleMenuClose(); setLogoutDialog(true); }}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MenuItem>
    </Menu>
  );

  console.log({selectedComponent})

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case "Courses":
        return <CourseManagement />;
      case "Student":
        return <StudentManagement />;
      case "Registration":
        return <RegistrationManagement />;
      case "Employee":
        return <EmployeeManagement />;
      case "CenterUsers":
        return <CenterUserManagement />;
      case "CenterStudents":
        return <CenterStudentsView />;
      // case 'Users':
      //   return <Users />;
      // case 'Reports':
      //   return <Reports />;
      // case 'Settings':
      //   return <Settings />;
      default:
        return <CourseManagement />;
    }
  };

  const handleLogoutUser = async () => {

    try {
      const response = await userLogoutMutation();
      setLogoutDialog(false);

      toast.success(response?.data?.message || "Logout Successfully")
    } catch (error) {
      console.error("Error during logout:", error);
      toast.error(error?.response?.data?.message || "Something went wrong")
    }

  }

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          backgroundImage:
            "linear-gradient(to right, #454751d1 0%, #ebb57dc4 100%);",
          color: "#fff",
        }}
      >
        <Toolbar>
          {isMobile && (
            <IconButton
              color="inherit"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap>
            Dashboard
          </Typography>
          {/* <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search> */}
          <Box sx={{ flexGrow: 1 }} />
          {/* <IconButton size="large" color="inherit">
            <Badge badgeContent={4} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}
          <IconButton
            size="large"
            edge="end"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <Logout sx={{ fontSize: 25 }} />
            {/* <Avatar sx={{ width: 32, height: 32 }} /> */}
          </IconButton>
        </Toolbar>
      </AppBar>
      <div style={{ marginTop: 20 }}>{renderMenu}</div>

      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={open}
        onClose={isMobile ? handleDrawerClose : undefined}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": open ? openedMixin(theme) : closedMixin(theme),
        }}
      >
        <DrawerHeader>
          <Typography variant="h6" sx={{ pl: 2 }}>
            Menu
          </Typography>
          <IconButton onClick={handleDrawerClose} sx={{ color: "#fff" }}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => setSelectedComponent("Course")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <AppsIcon fontSize="large" />
              </ListItemIcon>
              <Typography fontSize={15}>Courses</Typography>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => setSelectedComponent("Student")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <PeopleIcon fontSize="large" />
              </ListItemIcon>
              <Typography fontSize={15}>Students</Typography>
            </ListItemButton>
          </ListItem>


          <ListItem disablePadding>
            <ListItemButton onClick={() => setSelectedComponent("Registration")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <PermContactCalendarIcon fontSize="large" />
              </ListItemIcon>
              <Typography fontSize={15}>Registrations</Typography>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => setSelectedComponent("Employee")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <BadgeIcon fontSize="large" />
              </ListItemIcon>
              <Typography fontSize={15}>Employees</Typography>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => setSelectedComponent("CenterUsers")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <SupervisorAccountIcon fontSize="large" />
              </ListItemIcon>
              <Typography fontSize={15}>Center Users</Typography>
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton onClick={() => setSelectedComponent("CenterStudents")}>
              <ListItemIcon sx={{ color: "#fff" }}>
                <SchoolIcon fontSize="large" />
              </ListItemIcon>
              <Typography fontSize={15}>Center Students</Typography>
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        {renderSelectedComponent()}
      </Box>

      {/* Logout Confirmation Dialog */}
      <Dialog open={openLogoutDialog} onClose={() => setLogoutDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Logout User
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setLogoutDialog(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 3 }}>
          Are you sure you want to logout ?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setLogoutDialog(false)}
            sx={{ fontSize: 13, color: "#454751d1" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogoutUser}
            sx={{ fontSize: 13 }}
            variant="contained"
            disabled={isLoggingOut}
            color="error"
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
